import { useTranslation } from 'react-i18next';
import { useAtom } from 'jotai';
import { OrgHistoryFilterByEnum } from 'src/types';
import { historyFilterByAtom } from 'src/store';

type Props = {
  handleClick: () => void;
};

export const FilterOrgItems = ({ handleClick }: Props) => {
  const [filterBy, setFilterBy] = useAtom(historyFilterByAtom);

  const { t } = useTranslation();

  return (
    <div className='flex w-full flex-col items-start gap-2'>
      <div className='inline-flex w-full justify-between p-3 pb-0'>
        <span className='whitespace-nowrap font-secondary text-primary-dark'>
          {t('history.filters.org_label')}:
        </span>
      </div>
      <div
        className={`flex w-full flex-col items-start justify-center gap-2 pb-4 pl-6 pr-4`}
      >
        {Object.keys(OrgHistoryFilterByEnum).map((filter, i) => (
          <button
            key={`filter-${i}`}
            className={`w-full whitespace-nowrap py-0.5 text-left font-semibold transition-all ${
              filterBy === filter
                ? 'text-primary-dark hover:text-primary'
                : 'text-primary hover:text-primary-dark'
            }`}
            name={filter}
            onClick={(e) => {
              setFilterBy(
                e.currentTarget.name as keyof typeof OrgHistoryFilterByEnum,
              );
              handleClick();
            }}
          >
            {t(`history.filters.${filter}`)}
          </button>
        ))}
      </div>
    </div>
  );
};
